import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { Md5 } from 'ts-md5/dist/md5';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  model = { 'table_name': 'user', 'old_password': '', 'user_password': '', 'repeat_password': '' };
  user_id = '0';

  Success_Msg; Error_Msg; Curr_Password_Msg;
  Wrong_Curr_Pass_Msg; New_Pass_Msg; Pass_Rep_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Curr_Password_Msg').subscribe((res: string) => {
      this.Curr_Password_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Wrong_Curr_Pass_Msg').subscribe((res: string) => {
      this.Wrong_Curr_Pass_Msg = res;
    });

    translate.get('New_Pass_Msg').subscribe((res: string) => {
      this.New_Pass_Msg = res;
    });

    translate.get('Pass_Rep_Msg').subscribe((res: string) => {
      this.Pass_Rep_Msg = res;
    });
  }


  ngOnInit() {
    if (this.dialog_data != null)
      this.user_id = this.dialog_data['user_id'];
    else
      this.user_id = this.applicationConstants.user_info['user_id'];

  }

  save() {
    let old_password = String(Md5.hashStr(this.model['old_password']));

    if (this.dialog_data == null && this.model['old_password'] == '')
      alert(this.Curr_Password_Msg);
    else if (this.dialog_data == null && old_password != this.applicationConstants.user_info['user_password'])
      alert(this.Wrong_Curr_Pass_Msg);
    else if (this.model['user_password'] == '')
      alert(this.New_Pass_Msg);
    else if (this.model['user_password'] != this.model['repeat_password'])
      alert(this.Pass_Rep_Msg);
    else {
      this.model['user_password'] = String(Md5.hashStr(this.model['user_password']));
      let values = [{ 'table_name': this.model['table_name'], 'user_password': this.model['user_password'] }];
      let where = [{ 'user_id': this.user_id }];
      let obj = { cmd: 'update', values: values, where: where };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
